export default "__VITE_ASSET__BlTkvIqu__"